//zh.js中：
const zh = {
  login: {
    //登录页中文
    logintitle: "用户登录",
    platformTitle: "智慧预警管理平台",
    logbtn: "登录",
    rememberPassword: "记住密码",
    Pleaseenternumber:"请输入账号",
    Pleaseenteryourpassword:"请输入密码",
  },
  homepage: {
    //首页中文
    homeTitle: "智慧预警管理平台",
    welcomeTitle:"欢迎",
    LoggedOut:"退出登录",
    dashBoard:"数据看板",
    ChangePassword:"修改密码",
    OverviewSites:"监测点总览",
    EnergyMonitoring:"能耗监测",
    alarmCenter:"事件中心",
    HistoricalEvents:"历史事件",
    environmentalEvents:"环境事件",
    MonitoringManagement:"监测点管理",
    safetyReport:"安全报告",
    dataCenter:"数据中心",
    MonitoringList:"监测点列表",
    DeviceManagement:"设备管理",
    DeviceInformation:"设备信息",
    equipmentOperational:"设备运维",
    SystemManagement:"系统管理",
    OrganizationManagement:"组织管理",
    UserManagement:"用户管理",
    RoleManagement:"角色管理",
    LabelManagement:"标签管理",
    RiskManagement:"隐患管理",
    CloseAll:"关闭所有",
    CloseTags:"关闭其他标签",


  },
  mappage:{
    //地图页中文
    monitoringSites:"监测点总体概况",
    NewEquipment:"设备新装",
    NormalOperation:"运行正常",
    EarlyHiddendanger:"早期隐患",
    MediumHiddendanger:"中期隐患",
    OperationalHazards:"运行危险",
    PotentiaElectricshock:"设备触电隐患",
    SeriousHiddendanger:"设备严重隐患",
    InferiorEquipment:"劣质设备",
    PotentialElectricshock:"线路触电隐患",
    ZeroGroundhybridconnection:"零地混接",
    NonstandardWiring:"接线不规范",
    LineAging:"线路老化",
    ExcessiveContactresistance:"接触电阻过大",
    UnitDistributiondetails:"单位分布及详情",
    NameMeasuringpoint:"单位分布及详情",
    tableDetail:"详情",
    operation:"操作",
    StartEndTime:"起止时间",
    SelectStartTime:"选择开始时间",
    SelectEndTime:"选择结束时间",
    query:"查询",
    lastYear:"去年",
    thisYear:"今年",
    HiddenDangertrend:"隐患趋势",
    AccessIncrement:"接入增量",
    UnitScore:"单位隐患整改评分",
  },
  historyevent:{
    //历史事件页面中文
    DisposalStatus:"处置状态",
    PleaseSelect:"请选择",
    EventName:"事件名称",
    NameMonitoringpoint:"监测点名称",
    loading:"数据加载中",
    QueryResults:"查询结果",
    Weeklyreport:"周报告",
    Monthlyreport:"月报告",
    AllEvents:"所有事件",
    manager:"管理人",
    Completed:"已完成事件",
    incomplete:"未完成事件",
    AlarmValue:"告警值",
    startTime:"开始时间",
    Processingopinion:"处理意见",
    Reasondescribe:"原因描述",
    EventStatus:"事件状态",
    HandlingOpinions:"处理意见",
    handle:"处理",
    revise:"修改",
    eventProcessing:"事件处理",
    AlarmReason:"告警原因",
    ThresholdFeedback:"阈值反馈",
    reasonable:"合理",
    unreasonable:"不合理",
    confirm:"确认",
    cancel:"取消",
    Hasdisposal:"已处置",
    Notdisposed:"未处置",
  },
  powerpage:{
    //能耗页面中文
    EnergyStatistics:"能耗统计",
    today:"今日",
    ThisMonth:"本月",
    telephone:"手机号码",
    annual:"全年",
    CurrentElectricityconsumption:"本期用电量",
    ElectricityConsumptionperiod:"上期用电量",
    Proportionmonthlyelectricity:"月度用电占比",
    LastMonth:"上月",
    MonthlyValuecomparison:"月度能耗产值产量对比",
    TotalEnergyconsumption:"能耗总值",
    TotalOutputvalue:"产值总值",
    TotalOutput:"产量总值",
    piece:"件",
    Rankingvaluepoints:"监测点产值排名",
    OutputRankingpoints:"监测点产值排名",
  },
  stationListpage:{
    //监测点列表中文
    inputstationname:"请输入监测点名称",
    editType:"编辑分类",
    NewPoints:"新增监测点",
    all:"全部",
    DeviceID:"设备id",
    LoopID:"回路id",
    signalIntensity:"信号强度",
    edit:"编辑",
    delete:"删除",
    allpick:"全选",
    selected:"已选中",
    personCharge:"负责人",
    contactInformation:"联系方式",
    positionInformation:"位置信息",
    AffiliatedUnit:"所属单位",
    equipment:"设备",
    position:"地址",
    loop:"回路",
    save:"保存",
    ClassificationPositions:"监测点分类",
    AddClassification:"添加分类",
    ToBeclassified:"待分类",
    classification:"当前分类",
    addtype:"新增分类",
    groupName:"分类名称",
  },
  savereportList:{
    //安全报告列表中文
    reportModel:"报告种类",
    reportTime:"报告时间",
    reset:"重置",
    securityReportlist:"安全报告列表",
    reportId:"报告id",
    reportName:"报告名称",
    generationTime:"报告生成时间",
    review:"查看",
    other:"其它",
  },
  savereportDetail:{
    //安全报告详情中文
    reportExport:"报告导出",
    OverallEvaluation:"整体评估",
    YourOverallsafety:"您的整体安全情况为",
    ThisWeek:"本周",
    ThisMonth:"本月",
    DailyScoring:"每日评分情况",
    DailyhiddendangerDistribution:"每日隐患分布情况",
    YourRectificationscore:"您的整改态度评分为",
    PercentagemonitoringPoints:"监测点整改评分占比情况",
    up:"以上",
    ProportionnotRectified:"未整改隐患占比情况",
    HiddenDangerdiagnosis:"隐患诊断",
    hiddenDangers:"您检测点隐患共监测出",
    includingMajorrisks:"其中重大风险",
    includingMajorrisksstation:"其中有重大风险的监测点有",
    largeRisks:"较大风险",
    mostHiddendangers:"您监测点隐患最多的为",
    hiddenDangershave:"发现隐患",
    alarmeventnumber:"您的告警事件有",
    PleaseHandling:"项，请注意处理",
    AlarmDiagnosis:"告警诊断",
    NoHiddendanger:"暂无隐患",
    findRisk:"发现隐患",
    DiagnosisConclusion:"诊断结论",
    diagnosis:"诊断",
    monitoringpoints:"个监测点",
    find:"共计发现",
    risk:"项隐患和",
    alarms:"项报警",
    includinglargerisksstation:" 个，有较大风险隐患的监测点有",
    rectificationmonitoringpoints:" 监测点隐患整改共计",
    including:"个，其中有",
    majorRisks:"项重大风险隐患和",
    deatilmain:"项较大风险隐患还未整改，需要重点排查，具体如下表所示：",
    HiddendangerLevel:"隐患等级",
    Hiddendangername:"隐患名称",
    Occurrencemonitoringpoint:"发生监测点",
    Hiddendangerreportingtime:"隐患上报时间",
  },
  numcenterPage:{
    //数据中心监测点中文
    realtimedata:"实时数据",
    freezeData:"冻结数据",
    hour:"小时",
    day:"日",
    month:"月",
    queryTime:"查询时间",
    selectYear:"选择年份",
    selectMonth:"选择月份",
    selectDay:"选择日期",
    chart:"图表",
    data:"数据",
    export:"导出",
  },
  equipmentListPage:{
    //设备信息列表页英文
    deviceModel:"设备型号",
    enableState:"启用状态",
    enable:"启用",
    deactivate:"停用",
    connectState:"连接状态",
    onlineState:"在线状态",
    online:"在线",
    offline:"离线",
    deviceName:"设备名称",
    inputDevicename:"请输入设备名称",
    deviceImei:"设备imei",
    inputdeviceImei:"请输入设备imei",
    addHost:"添加主机",
    batchDelete:"批量删除",
    batchGeneration:"批量生成",
    onlineDevice:"在线设备",
    offlineDevice:"离线设备",
    UploadHost:"上传主机数据",
    downloadHosttemplate:"下载主机模板",
    uploadSlave:"上传从机数据",
    downloadSlavetemplate:"下载从机模板",
    circusNumber:"回路数",
    circusModel:"回路类型",
    startStop:"启停",
    connectStatus:"连接状态",
    unconnect:"未连接",
    connected:"已链接",
    ProtocolType:"协议类型",
    updateTime:"更新时间",
    viewDevice:"查看设备",
    viewCircle:"查看回路",
    externalDevices:"外接设备",
    addSlave:"新增从机",
    giveAddress:"地址下发",
    simNumber:"物联网卡号",
    remark:"备注",
    uploadImage:"图片上传",
    terminalName:"终端名称",
    communicationAddress:"通信地址",
    CircleName:"监测回路名称",
    status:"状态",
    normal:"正常",
    malfunction:"故障",
    EditCircle:"编辑回路",
    SelectMonitoring:"监测点选择",
    AddMonitoring:"监测点新增",
    ReviewImages:"查看图片",
    MassProduction:"批量生成",
    ManuallyAdd:"手动添加",
    restart:"重启",
    getdata:"获取数据",
    ObtainingRealtimeparameters:"获取实时数据",
    GetsfreezingParametersathour:"获取时冻结参数",
    GetsfreezingParametersatday:"获取日冻结参数",
    GetsfreezingParametersatmonth:"获取月冻结参数",
    ObtainingDeviceParameters:"下发获取指令",
    readParam:"读取参数",
    SetTheparameters:"设置参数",
    DownloadTheframe:"下载帧",
    ConnectedOffline:"已连接离线",
    ConnectionOnline:"已连接在线",
    Theserialnumber:"序号",
    parameterName:"参数名称",
    parameterValue:"参数值",
    Setthethreshold:"设置阈值",
    Insulationaginglevel:"绝缘老化一级",
    Insulationaginglevel2:"绝缘老化二级",
    Insulationaginglevel3:"绝缘老化三级",
    Electricalfirelevel1:"电气火灾一级",
    Electricalfirelevel2:"电气火灾二级",
    Electricalfirelevel3:"电气火灾三级",
    CheckCircuit:"查看回路",
    RunningState:"运行状态",
    ThresholdConfiguration:"阈值配置",
    chooseTime:"选择时间",
    EditParameters:"编辑参数",
    hostMachineimei:"宿主机imei",
    frameData:"帧数据",
    directionType:"方向类型",
    location:"位置",
  },
  systemPage:{
    //系统管理中文页
    OrganizationalStructure:"组织架构",
    newOrganization:"新增组织",
    DeleteTheorganization:"删除组织",
    OrganizeInformation:"组织信息",
    EditTheinformation:"编辑信息",
    ConfirmTosubmit:"确认提交",
    superiorOrganization:"上级组织",
    OrganizationName:"组织名称",
    longitude:"经度",
    latitude:"纬度",
    unitLabel:"单位标签",
    add:"添加",
    OrganizationDescriptions:"组织描述",
    userInformation:"用户信息",
    userName:"用户名",

    AccountStatus:"帐号状态",
    OrganizationalHierarchy:"组织层级",
    Newusers:"新增用户",
    user:"使用人",
    plaseInput:"请输入",
    organization:"所属组织",
    role:"角色",
    UserLabel:"用户标签",
    ModifyThetime:"修改时间",
    password:"密码",
    roleList:"角色列表",
    newRole:"新增角色",
    roleName:"角色名称",
    RoleOfnote:"角色备注",
    menuPermission:"菜单权限",
    roleDescribe:"角色描述",
    LabelTypeManagement:"标签类型管理",
    LabelManagement:"标签管理",
    newLabels:"新增标签",
    labelsId:"标签id",
    labelType:"标签类型",
    labelName:"标签名称",
    addLabeltype:"新增标签类型",
    addTime:"创建时间",
    hiddenDangerlevel:"隐患等级",
    hiddenDangertype:"隐患类型",
    HiddenDangerlist:"隐患列表",

  },
  allitem:{
    //一些通用的词条中文
    ConfirmtheDeletion:"确认删除?",
    SubmittedSuccessfully:"提交成功",
    submitFailure:"提交失败",
    HandleAsuccessful:"处理成功",
    dealwithfailure:"处理失败",
    determine:"确认",
    Deletedsuccessfully:"删除成功",
    DeleteFailed:"删除失败",
    Failuretomodify:"修改失败",
    addsuccess:"新增成功",
    AddFailure:"新增失败",
    Editlabeltype:"编辑标签类型",
    Editlabel:"编辑标签",
    Editingtherole:"编辑角色",
    PleaseDepartmentfirst:"请先选择部门",
    deletesure:"删除设备会清空该设备的所有数据，确认删除?",
    Uploadedsuccessfully:"上传成功",
    Uploadfailed:"上传失败",
    hosttemplate:"主机模板",
    machinetemplate:"从机模板",
    Modifysuccess:"修改成功",
    Editthehost:"编辑主机",
    Editmachine:"编辑从机",
    movedslavemachine:"移动主机时，所属从机将一并移动",
    Lookhost:"查看主机",
    Lookslave:"查看从机",
    Sendingsucceeded:"发送请求成功!",
    timeirst:"请先选择时间",
    Failedsend:"发送请求失败",
    Sendingquerysucceeded:"发送查询请求成功",
    querysuccessful:"查询成功!",
    Sendingrequestsucceeded:"发送重启请求成功!",
    Onlyonelabel:"同类型下仅可选择一个标签!",
    Edittheuser:"编辑用户",
  },
  stationdetail:{
    //监测点详情页面中文
    details:"详情",
    HiddenDangerhistory:"隐患历史",
    Getreatimedata:"获取实时数据",
    ComprehensiveMonitoring:"综合监测",
    SafetyMonitoring:"安全监测",
    Monitorsitesafetydata:"监测点安全数据",
    ResidualCurrent:"剩余电流",
    MessageManagement:"短信管理",
    ResidualFundamentalcurrent:"剩余基波电流",
    temperature:"温度",
    ElectricalFirerisk:"电气火灾风险指数",
    InsulationAgingrisk:"绝缘老化风险指数",
    savety:"安全",
    Selecthiddentrouble:"隐患选择",
    Pushtheconfiguration:"推送配置",
    Selecwarm:"告警选择",
    early:"早期",
    medium:"中期",
    dangerous:"危险",
    voltage:"电压",
    current:"电流",
    HarmonicCurrent:"谐波电流",
    ActivePower:"有功功率",
    powerFactor:"功率因数",
    APhase:"A相",
    BPhase:"B相",
    CPhase:"C相",
    RiskIndicators:"风险指标",
    currentData:"电流数据",
    ElectricityConsumptionstatistics:"用电情况统计",
    AlarmEventstatistics:"报警事件统计",
    EnergyConsumptionmonitoring:"能耗监测",
    Ratioofelectricityconsumptiontoday:"今日用电占比",
    Electricitytoday:"监测点今日用电量/单位今日用电量",
    yesterday:"昨日同期",
    sequential:"环比",
    TotalEnergyconsumptionyesterday:"昨日总能耗",
    thedaybeforeyesterday:"前日同期",
    EnergyConsumptionofthismonth:"本月能耗",
    powerQuality:"电能质量",
    HiddenTroubledisposal:"隐患处置",
    disposalofhistory:"处置历史",
    WeeksData:"周数据",
    monthsData:"月数据",
    dayData:"日数据",
    yearData:"年数据",
    EnergyconsumptionTrendStatistics:"能耗趋势统计",
    ProductionConfiguration:"产值配置",
    DownloadTemplate:"下载模板",
    UploadData:"上传数据",
    ExportData:"导出数据",
    VoltageHarmonic:"电压谐波",
    CurrentHarmonic:"电流谐波",
    Reactivepower:"无功功率",
    Feedervoltage:"馈线电压",
    loadCurrent:"负荷电流",
    FundamentalWavecurrent:"基波电流",
    Residualharmoniccurrent:"剩余谐波电流",
    Insulationresistance:"绝缘电阻",
    loadpower:"负荷功率",
    LoadPowerfactor:"负荷功率因数",
    Loadreactivepower:"负荷无功功率",
    remainingPower:"剩余功率",
    electricity:"电度",
    frequency:"频率",
    nodata:"暂无数据",
    fundamentalWavepower:"基波功率",
    Apparentpower:"视在功率",
    ActiveElectricaldegrees:"有功电度",
    HiddendangerHistory:"隐患历史记录",
    rectificationstatus:"整改状态",
    Reporttime:"上报时间",
    IssuedSuccessful:"下发成功",
    newequipment:"新增设备",
    Editequipment:"编辑设备",
    newhost:"新增主机",
    Devicecontrol:"设备控制",
    breakbrake:"分闸",
    closing:"合闸",

  }

}

export default zh;
